const stages = {
  stage: "Etapa",
  stages: "Etapas",
  add_stage: "Agregar etapa",
  edit_stage: "Editar etapa",
  stage_name: "Nombre de la etapa",
  name: "Nombre",
  status: "Estado",
  actions: "Acciones",
  active: "Activo",
  inactive: "Inactivo",
  is_active: "Activo",
  edit: "Editar",
  delete: "Eliminar",
  cancel: "Cancelar",
  add: "Agregar",
  update: "Actualizar",
  name_required: "El nombre es obligatorio",
  no_stages_found: "No se encontraron etapas",
  delete_stage_title: "Eliminar etapa",
  delete_stage_description:
    "¿Está seguro de que desea eliminar esta etapa? Esta acción no se puede deshacer.",
  stage_created_successfully: "Etapa creada correctamente",
  stage_updated_successfully: "Etapa actualizada correctamente",
  stage_deleted_successfully: "Etapa eliminada correctamente",
  user_management: "Gestión de usuarios",
  something_went_wrong: "Algo salió mal",
};

export default stages;
